var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrdered(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 36,
    viewBox: "0 0 83 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ordered",
    transform: "translate(-588 -536)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11156",
    "data-name": "Rectangle 11156",
    width: 83,
    height: 36,
    rx: 8,
    transform: "translate(588 536)",
    fill: "#0074d7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "send",
    transform: "translate(639 542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47196",
    "data-name": "Path 47196",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47197",
    "data-name": "Path 47197",
    d: "M3.4,20.4l17.45-7.48a1,1,0,0,0,0-1.84L3.4,3.6a.993.993,0,0,0-1.39.91L2,9.12a.994.994,0,0,0,.87.99L17,12,2.87,13.88a1.012,1.012,0,0,0-.87,1l.01,4.61A.993.993,0,0,0,3.4,20.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "send-2",
    "data-name": "send",
    transform: "translate(596 559)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "Tajawal-Bold, Tajawal",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Send")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdered);
export default __webpack_public_path__ + "static/media/ordered.649b04ceb1fcef265c5054a25774671a.svg";
export { ForwardRef as ReactComponent };